import { Tooltip } from 'antd';
import classname from 'classnames';
import React from 'react';
import { FormattedMessage } from 'react-intl';

import { ExtraFieldStatus } from './types';

const ExtraField: React.FC<{ labelId: string; data: string; status?: ExtraFieldStatus; tooltip?: string }> = ({
  labelId,
  data,
  status = ExtraFieldStatus.DEFAULT,
  tooltip,
}) => {
  const className = classname({
    'gx-text-danger': status === ExtraFieldStatus.DANGER,
    'gx-text-black': status !== ExtraFieldStatus.DANGER,
    'gx-mr-1': !!tooltip,
  });
  return (
    <span className='gx-fs-md'>
      <FormattedMessage id={labelId} />
      {`: `}
      <span className={className}>{data}</span>
      {tooltip && (
        <Tooltip placement='bottomRight' title={tooltip}>
          <i className='icon icon-spam gx-text-danger gx-fs-sm' />
        </Tooltip>
      )}
    </span>
  );
};
export default React.memo(ExtraField);
